import { render, staticRenderFns } from "./campaign-highlights.vue?vue&type=template&id=585b2c6c&scoped=true&"
import script from "./campaign-highlights.vue?vue&type=script&lang=js&"
export * from "./campaign-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b2c6c",
  null
  
)

export default component.exports